import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './sessionInstanceChatShimmerComponent.css';

const SessionInstanceChatShimmerComponent = () => {
  return (
    <div className="et-session-instance-chat-shimmer-container">
      <div className="et-ssicc-content-wrap">
        <div className="et-ssicc-video-icon-status-time-wrap">
          <div className="et-ssicc-video-icon-status-wrap">
            <div className="et-ssicc-icon">
              <ShimmerComponent />
            </div>
            <div className="et-ssicc-status-pill">
              <ShimmerComponent />
            </div>
          </div>
          <div className="et-ssicc-time">
            <ShimmerComponent />
          </div>
        </div>
        <div className="et-ssicc-participants-info-wrap">
          <div className="et-ssicc-info-participants-icon">
            <div className="et-ssicc-icon-small">
              <ShimmerComponent />
            </div>
          </div>
          <div className="et-ssicc-participants-count">
            <ShimmerComponent />
          </div>
        </div>
        <div className="et-ssicc-join-btn">
          <div className="et-ssicc-button">
            <ShimmerComponent />
          </div>
        </div>
        <div className="et-ssicc-call-recordings-wrap">
          <div className="et-ssicc-recording-container">
            <div className="et-ssicc-video-section-wrap">
              <div className="et-ssicc-video-section">
                <ShimmerComponent />
              </div>
            </div>
            <div className="et-ssicc-summary-transcription-wrap">
              <div className="et-ssicc-st-text-open-btn-wrap">
                <div className="et-ssicc-transcription-header">
                  <ShimmerComponent />
                </div>
                <div className="et-ssicc-open-btn">
                  <ShimmerComponent />
                </div>
              </div>
              <div className="et-ssicc-transcription-content-wrap">
                <div className="et-ssicc-transcription-content">
                  <div className="et-ssicc-transcription-item">
                    <ShimmerComponent />
                  </div>
                  <div className="et-ssicc-transcription-item">
                    <ShimmerComponent />
                  </div>
                  <div className="et-ssicc-transcription-item">
                    <ShimmerComponent />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="et-ssicc-recording-container">
            <div className="et-ssicc-video-section-wrap">
              <div className="et-ssicc-video-section">
                <ShimmerComponent />
              </div>
            </div>
            <div className="et-ssicc-summary-transcription-wrap">
              <div className="et-ssicc-st-text-open-btn-wrap">
                <div className="et-ssicc-transcription-header">
                  <ShimmerComponent />
                </div>
                <div className="et-ssicc-open-btn">
                  <ShimmerComponent />
                </div>
              </div>
              <div className="et-ssicc-transcription-content-wrap">
                <div className="et-ssicc-transcription-content">
                  <div className="et-ssicc-transcription-item">
                    <ShimmerComponent />
                  </div>
                  <div className="et-ssicc-transcription-item">
                    <ShimmerComponent />
                  </div>
                  <div className="et-ssicc-transcription-item">
                    <ShimmerComponent />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionInstanceChatShimmerComponent;
